// src/components/CommunityCarousel.js

import React from 'react';
// Swiper React bileşenlerini ve stillerini import ediyoruz
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

// Gerekli modülleri import ediyoruz
import { Autoplay } from 'swiper/modules';

const CommunityCarousel = () => {
  // Gösterilecek resimlerin yolları (ilk 25 tanesi)
  const carouselImages = Array.from({ length: 25 }, (_, i) => `/images/community/community (${i + 1}).jpg`);

  return (
    <section className="multi-carousel-section py-5 bg-light-section">
      <div className="container-fluid"> {/* Tam genişlik için container-fluid */}
        <div className="text-center mb-5">
          <h2 className="cb-title">Community Moments</h2>
          <p className="lead text-muted">Highlights from our events and workshops.</p>
        </div>
        <Swiper
          modules={[Autoplay]} // Otomatik oynatma modülünü ekliyoruz
          spaceBetween={15} // Fotoğraflar arası boşluk
          slidesPerView={2} // Mobil için varsayılan görünüm
          loop={true} // Sürekli dönme efekti
          autoplay={{
            delay: 2500, // 2.5 saniyede bir fotoğraf geçer
            disableOnInteraction: false, // Kullanıcı etkileşiminden sonra durmaz
          }}
          breakpoints={{
            // 768px ve üzeri ekranlarda
            768: {
              slidesPerView: 6, // 6 fotoğraf göster
              spaceBetween: 20,
            },
          }}
          className="mySwiper"
        >
          {carouselImages.map((src, index) => (
            <SwiperSlide key={index}>
              <img
                className="multi-carousel-image"
                src={src}
                alt={`Community moment ${index + 1}`}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default CommunityCarousel;